import React from 'react';
import PropTypes from 'prop-types';
import fetch from 'cross-fetch';

import KitInsertSearchResults from "./Features/KitInsertSearchResults";

import { TranslationUtility } from '../util/translationUtility';

class KitInsertSearchApp extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchTerm: props.SearchTerm,
            documents: props.Results,
        };

        this.translationUtilty = new TranslationUtility(props.LocalizationItems);

        if (window !== undefined && window.$ !== undefined) {
            this.noResults = window.$(".js-kit-insert-search-no-results");
        }

        this.onSearchTermChange = this.onSearchTermChange.bind(this);
        this.onSearchTermKeyUp = this.onSearchTermKeyUp.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.replaceQueryString = this.replaceQueryString.bind(this);
    }

    onSearchTermChange(e) {
        this.setState({ searchTerm: e.target.value });
        this.noResults.hide();
    }

    onSearchTermKeyUp(e) {
        if (e.keyCode === 13) {
            this.onSearch();
        }
    }

    onSearch() {
        const { searchTerm } = this.state;
        this.replaceQueryString(searchTerm);
        const { ApiEndPoint } = this.props;
        fetch(`${ApiEndPoint}?searchTerm=${searchTerm}`)
            .then(response => response.json())
            .then(result => this.setSearchResult(result));
    }

    setSearchResult(result) {
        if (this.state.searchTerm && (!result.documents || result.documents.length === 0)) {
            this.noResults.show();
        } else {
            this.noResults.hide();
        }

        this.setState({ documents: result.documents });
    }

    replaceQueryString(searchTerm) {
        if (window.history.replaceState) {
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + `?searchTerm=${searchTerm}`;
            window.history.replaceState({path:newurl},'',newurl);
        }
    }

    render() {
        return (
            <div>
                <div className="sds-search-wrapper">
                    <input
                        type="text"
                        className="form-control mr-3"
                        placeholder={this.translationUtilty.translateResourceString("/KitInsertSearchPage/SearchBoxPlaceholder")}
                        onKeyUp={this.onSearchTermKeyUp}
                        onChange={this.onSearchTermChange}
                    />
                    <input
                        type="button"
                        value={this.translationUtilty.translateResourceString("/KitInsertSearchPage/SearchButtonText")}
                        onClick={this.onSearch}
                        className="btn btn-xs btn-neogen-green"
                    />
                </div>
                <div>
                    <KitInsertSearchResults
                        items={this.state.documents}
                        translationUtilty={this.translationUtilty}
                    />
                </div>
            </div>
        );
    }
}

KitInsertSearchApp.propTypes = {
    ApiEndPoint: PropTypes.string,
    LocalizationItems: PropTypes.array,
    Results: PropTypes.arrayOf(PropTypes.object),
    SearchTerm: PropTypes.string
};

export default KitInsertSearchApp;